import React from 'react';
import PageMeta from '../components/common/PageMeta';
import ContactBox from '../components/contact/ContactBox';
import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';

const Contact = () => {
  return (
    <Layout>
      <PageMeta title='Kontakt - elintech GmbH' />
      <Navbar navLight />

      <ContactBox />

      <FooterOne
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      />
    </Layout>
  );
};

export default Contact;

